

$(document).ready(function () {

    $("a#toggle-chatbot").click(function () {
        var displayValue = $("#chatbot").css('display');
        if (displayValue == "flex") {
            $("#chatbot-wrapper").removeClass("active");
        } else {
            $("#chatbot-wrapper ").addClass("active");
        }
    });

    $("a#close-chatbot").click(function () {
        $("#chatbot-wrapper").removeClass("active");
    });

    $("#send-button").click(function () {
        sendMessage();
    });

    var userInput = document.getElementById('user-input');
    if (userInput) {
        userInput.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                $("#send-button").trigger("click");
            }
        });
    }

});


function sendMessage() {
    var userInput = document.getElementById('user-input');
    var message = userInput.value.trim();

    if (message) {
        addMessage(message, 'user-message');
        userInput.value = '';

        $("#typing-indicator").removeClass('hidden');

        // Stuur de vraag naar je API
        fetch('https://retailer-staging.giant-bicycles.com/Api/AiPlayground/VectorDatabaseQuestion', {
            method: 'POST',
            headers: {
                'X-Api-Key': 'f23e6b24-1dac-40ea-b38a-e6cbd885fa03',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ Question: message })
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {

                $("#typing-indicator").addClass('hidden');

                // Toon het antwoord van je API
                addMessage(data.answer, 'bot-message');
            })
            .catch(function (error) {
                console.error('Error:', error);

                $("#typing-indicator").addClass('hidden');

                addMessage('Something went wrong. Please try again.', 'bot-message');
            });
    }
}

function addMessage(text, className) {
    var messagesDiv = document.getElementById('messages');
    var messageDiv = document.createElement('div');
    messageDiv.className = 'message ' + className;
    messageDiv.textContent = text;
    messagesDiv.appendChild(messageDiv);

    // Scroll naar de onderkant
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
}